import * as React from 'react';
import {Select} from "antd";
import {ChecklistRentTypeFilter, getChecklistFilterOptions} from "./ChecklistRentTypeFilter";

interface State {
  value: ChecklistRentTypeFilter
}

interface Props {
  value?: ChecklistRentTypeFilter;
  onChange: (value: ChecklistRentTypeFilter) => void;
}

export default class ChecklistFilterSelector extends React.Component<Props, State> {

  public state: State = {
    value: this.props.value ? this.props.value : ChecklistRentTypeFilter.RENTAL
  };

  public render(): React.ReactElement {
    const {value} = this.state;

    const onChange = (filter: ChecklistRentTypeFilter) => {
      this.props.onChange(filter);
      this.setState({
        value: filter
      });
    };
    return (
      <Select size="small" style={{width: 250}} value={value} onChange={onChange}>
        {getChecklistFilterOptions()}
      </Select>
    );
  }
}


// WEBPACK FOOTER //
// ./src/checklist-alerts/ChecklistFilterSelector.tsx